import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import axios from '../utils/axiosInstance';

const AdminPanel = () => {
    const location = useLocation();
    const [isFrozen, setIsFrozen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [randomNumbers, setRandomNumbers] = useState([]);
    const [showNumbers, setShowNumbers] = useState(false);

    useEffect(() => {
        const fetchBoardStatus = async () => {
            try {
                const response = await axios.get('/board/status');
                setIsFrozen(response.data.isFrozen);
            } catch (err) {
                console.error('Error fetching board status:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchBoardStatus();
    }, []);

    const toggleFreezeStatus = async () => {
        try {
            const response = await axios.post('/admin/toggle-board');
            if (response.data.boardFrozen !== undefined) {
                setIsFrozen(response.data.boardFrozen);
            }
        } catch (err) {
            console.error('Error toggling board status:', err);
            alert('Failed to toggle game status. Please try again.');
        }
    };

    const generateRandomNumbers = async () => {
        try {
            const response = await axios.post('/admin/generate-random-numbers');
            setRandomNumbers(response.data.numbers || []);
            setShowNumbers(true);
        } catch (err) {
            console.error('Error generating random numbers:', err);
            alert('Failed to generate random numbers. Please try again.');
        }
    };

    const generateBreadcrumbs = () => {
        const paths = location.pathname.split('/').filter(Boolean);
        return paths.map((path, index) => {
            const to = `/${paths.slice(0, index + 1).join('/')}`;
            const formattedPath = path.charAt(0).toUpperCase() + path.slice(1).replace('-', ' ');
            return (
                <span key={to}>
                    {index !== paths.length - 1 ? <Link to={to}>{formattedPath}</Link> : formattedPath}
                </span>
            );
        });
    };

    if (loading) {
        return <div>Loading Admin Panel...</div>;
    }

    return (
        <div className="admin-panel">
            <header>
                <h1>Admin Panel</h1>
                <p>Welcome! Manage your grid fundraiser efficiently.</p>
            </header>
            <div className="sections">
                <section>
                    <h2>Manage</h2>
                    <ul>
                        <li><Link to="/admin/price">Price</Link></li>
                        <li><Link to="/board/add-teams">Teams</Link></li>
                        <li><Link to="/admin/players">Players</Link></li>
                        <li><Link to="/admin/squares">Squares</Link></li>
                        <li><Link to="/admin/users">Admin Users</Link></li>
                    </ul>
                </section>
                <section>
                    <h2>Production</h2>
                    <ul>
                        <li>
                            <Link 
                                className={isFrozen ? 'button button-unfreeze' : ''}
                                onClick={toggleFreezeStatus}>
                                {isFrozen ? 'Unfreeze Game' : 'Freeze Game'}
                            </Link>
                        </li>
                        <li><Link to="/admin/generate-random-numbers">Generate Random Numbers</Link></li>
                        <li><Link to="/admin/generate-pdf">Generate PDF</Link></li>
                        <li><Link to="/admin/email-clients">Email Clients</Link></li>
                    </ul>
                    {showNumbers && randomNumbers.length > 0 && (
                        <div>
                            <h3>Generated Numbers</h3>
                            <p>{randomNumbers.join(', ')}</p>
                        </div>
                    )}
                </section>
            </div>
            <main>
                <Outlet />
            </main>
        </div>
    );
};

export default AdminPanel;